import {createContext, PropsWithChildren, useCallback, useMemo, useState} from "react";
import {Task2, TaskBoard, TaskBoardCard, TaskBoardColumn, TaskSimple} from "../../api/Tasks2";
import {ViewTask} from "./ViewTask";
import {EventEmitter} from "nate-react-api-helpers";
import {ViewColumn} from "./ViewColumn";
import {useSyncedRef} from "../../misc/SyncedRef";

export const BoardContext = createContext({
    onShowCard: (input: ShowCardInput) => {},
    onShowColumn: (input: TaskBoardColumn) => {},
    refreshColumnsEmitter: new EventEmitter(),
    refreshEverything: () => {},

    columnLoadPending: [] as number[],
    setColumnLoadPending: (input: number[]) => {

    },
    reloadColumns: (input: number[]) => {

    },
    columnReloadEmitter: new EventEmitter<number>(),
    board: "missing" as any as TaskBoard,
})

export type ShowCardInput = {
    value: Task2 | TaskSimple;
    column: TaskBoardColumn;
    card: TaskBoardCard;
}

export function BoardContextProvider(props: PropsWithChildren<{
    refresh: () => void;
    board: TaskBoard;
}>) {
    const [showCard, setShowCard] = useState<ShowCardInput>();
    const [showColumn, setShowColumn] = useState<TaskBoardColumn>();
    const refreshColumnsEmitter = useMemo(() => new EventEmitter(), []);
    const refreshRef = useSyncedRef(props.refresh);
    const refreshEverything = useCallback(() => refreshRef.current(), [refreshRef]);

    const [columnLoadPending, setColumnLoadPending] = useState<number[]>([]);
    const columnReloadEmitter = useMemo(() => new EventEmitter<number>(), []);

    const board = props.board;
    const ctx = useMemo(() => ({
        onShowCard: setShowCard,
        onShowColumn: setShowColumn,
        refreshColumnsEmitter,
        refreshEverything,
        setColumnLoadPending,
        columnLoadPending,
        columnReloadEmitter,
        reloadColumns: (input) => {
            setColumnLoadPending([]);
            input.forEach(v => columnReloadEmitter.emit(v));
        },
        board: board,
    }), [refreshColumnsEmitter, setShowCard, refreshEverything, columnLoadPending, columnReloadEmitter, board]);

    return (
        <BoardContext.Provider value={ctx}>
            {props.children}
            {showCard && <ViewTask id={showCard.card.task2} {...showCard} onClose={() => {
                if(showCard) {
                    columnReloadEmitter.emit(showCard.column.id);
                }

                setShowCard(undefined);
            }} />}
            {showColumn && <ViewColumn value={showColumn} onClose={() => {
                setShowColumn(undefined);
            }} />}
        </BoardContext.Provider>
    )
}